import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const CalendarHeader = ({ calendarMonth, onMonthChange, minDate, maxDate }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={2}>
      <IconButton
        onClick={() => onMonthChange(-1)}
        disabled={calendarMonth.isSame(minDate.startOf("month"), "month")}>
        <ChevronLeft />
      </IconButton>
      <Typography variant="subtitle1">
        {calendarMonth.format("MMMM YYYY")}
      </Typography>
      <IconButton
        onClick={() => onMonthChange(1)}
        disabled={calendarMonth.isAfter(maxDate.startOf("month"), "month")}>
        <ChevronRight />
      </IconButton>
    </Box>
  );
};

export default CalendarHeader;
